import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PolizaDetailsComponent } from 'app/components/polizas/poliza-details/poliza-details.component';
import { showNotification } from 'app/shared/factories/notifications';
import { estatusPoliza } from 'app/shared/models/estatusPoliza';
import { poliza } from 'app/shared/models/poliza';
import { ramo } from 'app/shared/models/ramo';
import { estatusTramite } from 'app/shared/models/tramite';
import { AuthService } from 'app/shared/services/auth.service';
import { EstatusPolizaService } from 'app/shared/services/estatus-poliza.service';
import { PolizasService } from 'app/shared/services/polizas.service';
import { RamosService } from 'app/shared/services/ramos.service';
import { Observable, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, catchError } from 'rxjs/operators';


@Component({
  selector: 'component-cobranza-list',
  templateUrl: './cobranza-list.component.html',
  styleUrls: ['./cobranza-list.component.css']
})
export class CobranzaListComponent implements OnInit {
  @Input() fromModal: boolean;
  @Input() modalAdd: boolean;
  @Input('agente-id') agenteId: number;
  @Input('cliente-id') clienteId: number;
  polizas: poliza[];
  ramos: ramo[];
  search: string;
  pagination: any;
  isWorking: boolean;
  allowModify: boolean;
  filter: {
    month: number,
    year: number
  } = { month: 0, year: 0};
  today: Date;
  months: Array<{ sMonth, iMonth}>;
  constant_months: Array<{ sMonth, iMonth}>;
  years: Array<number>;
  
  estatuses: estatusPoliza[];
  etramite: number;
  eramo: number;

  displayedColumns: string[] = ['Polizas.Id', 'Agentes.Nombre', 'Clientes.Nombre', 'Polizas.FechaEmision', 'Polizas.Expiracion', 'Polizas.FechaRenovacion', 'Polizas.NumeroPoliza', 'Ramos.Nombre', 'Productos.Nombre', 'Polizas.MontoPoliza', 'ConductosCobro.Nombre', 'FormasPago.Nombre', 'EstatusPoliza.Nombre'];
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(private polizasService: PolizasService,
    public authService: AuthService,
        public modal: NgbModal, 
        public router: Router, 
        public activatedRoute: ActivatedRoute, 
        public estatusPolizaService: EstatusPolizaService,
        public ramoService: RamosService,
        public activeModal: NgbActiveModal) { 
        this.polizas = [];
        this.ramos = [];
        this.search = '';
        this.isWorking = false;
        
        this.estatuses = new Array<estatusPoliza>();
        this.etramite = 0;
        this.eramo = 0;
        
        this.allowModify = this.authService.idagente == 0;  

        let d = new Date();
        this.today = d;

        this.filter.month = d.getMonth() + 1;
        this.filter.year = d.getFullYear();

        this.months = new Array<{ sMonth: string, iMonth: number}>();
        this.constant_months = new Array<{ sMonth: string, iMonth: number}>();
        this.constant_months.push({ sMonth: "ENERO", iMonth: 1});
        this.constant_months.push({ sMonth: "FEBRERO", iMonth: 2});
        this.constant_months.push({ sMonth: "MARZO", iMonth: 3});
        this.constant_months.push({ sMonth: "ABRIL", iMonth: 4});
        this.constant_months.push({ sMonth: "MAYO", iMonth: 5});
        this.constant_months.push({ sMonth: "JUNIO", iMonth: 6});
        this.constant_months.push({ sMonth: "JULIO", iMonth: 7});
        this.constant_months.push({ sMonth: "AGOSTO", iMonth: 8});
        this.constant_months.push({ sMonth: "SEPTIEMBRE", iMonth: 9});
        this.constant_months.push({ sMonth: "OCTUBRE", iMonth: 10});
        this.constant_months.push({ sMonth: "NOVIEMBRE", iMonth: 11});
        this.constant_months.push({ sMonth: "DICIEMBRE", iMonth: 12});

        this.months = this.constant_months;
        /*if(this.filter.year == d.getFullYear()){
          this.months = this.constant_months.filter(m => m.iMonth <= d.getMonth() + 1);
        }else{
          this.months = this.constant_months;
        }*/

        console.log('FILTERED MONTHS', this.months);

        this.years = new Array<number>();
        for(let fY = 2018; fY <= d.getFullYear(); fY++){
          this.years.push(fY);
        }

        console.log('FILTERED YEARS', this.years);
    }

  ngOnInit(): void {
    this.getRamos();
    this.getEstatuses();  }

   ngAfterViewInit(){
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.load();
  }

  load(){
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.polizasService.getCobranzaProxima(
            this.filter.month,
            this.filter.year,
            this.search,
            this.eramo,
            this.sort.active,
            this.sort.direction,
            this.paginator.pageIndex).pipe(catchError((err) => of(null)));
        }),
        map((data: any) => {
          // Flip flag to show that loading has finished.
          console.log(data);
          this.isLoadingResults = false;
          this.isRateLimitReached = data.data.length === 0;

          if (data === null) {
            return [];
          }

          // Only refresh the result length if there is new data. In case of rate
          // limit errors, we do not want to reset the paginator to zero, as that
          // would prevent users from re-triggering requests.
          this.resultsLength = data.totalItems;
          return data.data;
        }),
      )
      .subscribe(data => (this.polizas = data));
  }

  getRamos(){
    this.ramoService.get().subscribe(resp => {
      console.log('GET RAMOS', resp);
      if(resp.status){
        this.ramos = resp.data;
      }
    });
  }

  getEstatuses(){
    this.estatusPolizaService.get().subscribe(resp => {
      console.log('GET ESTATUSES', resp);
      if(resp.status){
        this.estatuses = resp.data;
      }
    }, err => {
      console.error('GETTING ESTATUSES', err);
      showNotification('Ocurrió un error inesperado, por favor verifica tu conexión a internet', 'warning');
    });
  }

  paginate(page){
    this.toggleWorking();

    this.polizasService.getCobranzaProxima(
            this.filter.month,
            this.filter.year,
            this.search,
            this.eramo,
            this.sort.active,
            this.sort.direction,
            this.paginator.pageIndex).subscribe(resp => {
      console.log('GET POLIZAS', resp);
      if(resp.status){
        this.polizas = resp.data;
        this.pagination.collectionSize = resp.totalItems;
      }else{
        showNotification(resp.message, 'danger');
      }
      this.toggleWorking();
    }, err => {
      console.error('GETTING POLIZAS', err);
      showNotification('Ocurrió un error inesperado, por favor verifica tu conexión a internet', 'danger');
      this.toggleWorking();
    });
  }

  toggleWorking(){
    this.isWorking = !this.isWorking;
  }

  searchBox = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.load())
    )

  detail(id){
  if(this.modalAdd){
    const modal = this.modal.open(PolizaDetailsComponent, {size: 'xl', centered: true, container: 'div', windowClass: 'p-5'});
    modal.componentInstance.idPoliza = id;
    modal.componentInstance.idAgente = this.agenteId;
    modal.componentInstance.idCliente = this.clienteId;
    modal.result.then(result => {
      if(result){
        this.load();
      }
    }, reject => {
      this.load();
    });
    }
    else{
      this.router.navigate(['./edit/', id], {relativeTo: this.activatedRoute});
    }
  }

}
